module.exports = __webpack_public_path__ + "img/8.dd6cacf8.jpg";